import packageService from "src/services/packageService";

export const GET_APPROVE_RETURN_INVOICE_REQUEST =
  "@invoice/get-approve-return-invoice-request";
export const GET_APPROVE_RETURN_INVOICE_SUCCESS =
  "@invoice/get-approve-return-invoice-success";
export const GET_APPROVE_RETURN_INVOICE_FAILURE =
  "@invoice/get-approve-return-invoice-failure";

export function getListInvoice(params = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_APPROVE_RETURN_INVOICE_REQUEST});
      const response = await packageService.getApproveReturnInvoice(params);
      dispatch({
        type: GET_APPROVE_RETURN_INVOICE_SUCCESS,
        payload: {
          response: response.data,
          total: response.total_items
        }
      });
    } catch (error) {
      dispatch({type: GET_APPROVE_RETURN_INVOICE_FAILURE});
      throw error;
    }
  };
}
